import { useDynamicForm } from "@/components/dynamic-form/hook/useDynamicForm";
import { useWatchPagination } from "@/components/dynamic-form/hook/useWatchPagination";
import { PageContainer } from "@/components/page-container";
import { TableContainer } from "@/components/table-container";
import { Table, Popover } from "@renderbus/ui";
import { enhanceEndTime } from "@/components/dynamic-form/formatter/enhanceEndTime";
import {
  OperationArea,
  SearchAreaWrapper,
} from "@/pages/consumption/components/atom";
import { DynamicForm } from "@/components/dynamic-form";
import { useSearchConfig } from "./hooks/useSearch";
import { getInitialValues } from "@/components/dynamic-form/helper/getInitialValues";
import { useColumns } from "./hooks/useColumns";
import { useEffect } from "react";
import { useFilterColumns } from "project-config/hooks/useFilterColumns";
import { useCustomColumns } from "project-config/hooks/useCustomColumns";
import { ColumnCheckboxes } from "@/pages/consumption/components/column-checkboxes";
import { OperationButton } from "@/components/operation-button";
import { useTranslation } from "react-i18next";

export function Machine() {
  const { t } = useTranslation("center");
  const { searchConfig } = useSearchConfig();
  const { columns } = useColumns();
  const { form, fetchData, tableData, pageNum, setPageNum, total, pageSize } =
    useDynamicForm({
      api: "/api/rendering/user/consume/bill/getUserPackNodeList",
      noPagination: true,
      formatter: {
        time: enhanceEndTime,
      },
    });
  const { checkedValue, onChange, defaultCheckData } = useCustomColumns(
    columns,
    "consumption_task_picture"
  );
  const { columns: filteredColumns } = useFilterColumns(columns, checkedValue);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useWatchPagination(pageSize, pageNum, fetchData);

  return (
    <PageContainer>
      <TableContainer>
        <SearchAreaWrapper>
          <DynamicForm
            initialValues={getInitialValues(searchConfig)}
            searchConfig={searchConfig}
            searchForm={form}
            onSearch={() =>
              fetchData({
                extraData: {
                  pageNum: 1,
                },
              })
            }
          />
          <OperationArea>
            <Popover
              content={
                <ColumnCheckboxes
                  columns={columns}
                  onChange={onChange}
                  value={checkedValue}
                  defaultValue={defaultCheckData}
                />
              }
            >
              <>
                <OperationButton text={t("consumption_custom_column")} />
              </>
            </Popover>
          </OperationArea>
        </SearchAreaWrapper>
        <Table
          paginationCurrent={pageNum}
          columns={filteredColumns}
          dataSource={tableData}
          gap={false}
          total={total}
          defaultPageSize={pageSize}
          onPageNumChange={async (num: number) => {
            setPageNum(num);
          }}
        />
      </TableContainer>
    </PageContainer>
  );
}
